var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutlineRuler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EBF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.1998C8 11.5372 8.58172 11 9.30001 11H19.7C20.418 11 21 11.5377 21 12.1998V15.8002C21 16.4628 20.4183 17 19.7 17H9.30001C8.58203 17 8 16.4623 8 15.8002V12.1998ZM9.3 12.2H19.7V15.8H9.3V12.2ZM10.4375 12.2H11.7375V14H10.4375V12.2ZM12.7125 12.2H14.0125V14H12.7125V12.2ZM14.9875 12.2H16.2875V14H14.9875V12.2ZM17.2625 12.2H18.5625V14H17.2625V12.2Z",
    fill: "#3C7AF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutlineRuler);
export default __webpack_public_path__ + "static/media/pencil-outline-ruler.051d71713de5c8950127b81a8e6987bd.svg";
export { ForwardRef as ReactComponent };